import { Action } from 'redux';

export const USER_LOGGED_OUT = 'USER_LOGGED_OUT';
export interface UserLoggedOutAction extends Action<typeof USER_LOGGED_OUT> {}
export const userLoggedOutAction = () => {
  return {
    type: USER_LOGGED_OUT
  };
};
